import type { FaireProductEntity } from "../../entity_types/product";

export const p_frtwxh3agn: FaireProductEntity = {
  token: "p_frtwxh3agn",
  type: "product",
  name: "HIGH NECK SLEEVELESS POINTELLE OPEN-KNIT TOP",
  brandToken: "b_2a388unpqo",
  brandName: "Bluivy",
  imageUrl: "https://cdn.faire.com/fastly/01cba2efd7ea12b9aef030198ab39659070e766e575de473359ef1faf5f8a44a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8ca5dc3982c759a9e4dbcee196df650018ae154a3b69c4ac108c9fafd8de1f3.jpeg",
    "https://cdn.faire.com/fastly/bca33acb64d0a04bd19855a0e3446596bcc8e87a390160b44eece1f9ff4384a0.jpeg",
    "https://cdn.faire.com/fastly/4a388f51c3969515bb7f529561a8f2edfa78bed5333abdf413361ebc4c6225c3.jpeg",
    "https://cdn.faire.com/fastly/1481c9292f490ff8e1a3f02bebc5ddd4625e0421798a249efb6ad0702ce08bd8.jpeg",
    "https://cdn.faire.com/fastly/dbeff4a2e30714e2cf9b1ea6d665781ee70e61e1bb63e62e7de2d67474a0636a.jpeg",
    "https://cdn.faire.com/fastly/a4144b6fb16a1ab3507d12765272de207d059266205664333334edf6805db05d.jpeg",
    "https://cdn.faire.com/fastly/a4239cf3fa2a5abe8a56123fb25abbe68b05f21add5ba456d1c5aeb8e3d0b6fa.jpeg",
    "https://cdn.faire.com/fastly/6d256957e1cf09f23d2ff20b9676d4d4796f651e177e8cff5e92b5f51d776df0.jpeg",
    "https://cdn.faire.com/fastly/cc4e1e96167fa477689e190bd7b423ee1c5e0bd276ec7c56d51039d726a17733.jpeg",
    "https://cdn.faire.com/fastly/e233cd8d3c51419329929d8539382ea1897e7644afc3949090563db344361a05.jpeg",
    "https://cdn.faire.com/fastly/98ed308ea71f443faa3c379f502b712150d7a93fb961aeca1ec9e45c1d494435.jpeg",
    "https://cdn.faire.com/fastly/b79240dcf48cc92b62d19ca1acf8ee0c024898ba6dba8d16054e1d247f659172.jpeg",
    "https://cdn.faire.com/fastly/b83ab550d8791fcd066f09b240d52fc67058e45bf7ef588b85bddce8be46fc63.jpeg",
    "https://cdn.faire.com/fastly/ad60ba25e606ea22006308fc6691ed6bd8362411b7801fb3e3638b084075a4d9.jpeg",
    "https://cdn.faire.com/fastly/7fa0662b0a221615103d2bb07efada03dc1045b9b6f518b98a35a432ea0b0a9d.jpeg",
    "https://cdn.faire.com/fastly/d993ee9723af0bb7485a5800f013e747286fb26d8d88fb32ac9fa659219f383f.jpeg",
    "https://cdn.faire.com/fastly/b0db2c685a1b7e4c9293cebd83cfc50bb60c598ff078f263a1e42bcab678c154.jpeg",
    "https://cdn.faire.com/fastly/d4d0e821ed0b001acf2e203e5e7a0d29dee4ada30279282c58f3ba9e440f660d.jpeg",
    "https://cdn.faire.com/fastly/00ef56ef345e52d4601b9a79bfd971d0609714bcab90467698fc420666e0e986.jpeg"
  ],
  priceDollars: 118.8,
  description: "Elevate your warm-weather wardrobe with this beautifully textured knit tank. Crafted from a breathable, mid-weight pointelle knit, this top features a sophisticated high-neck silhouette with a substantial ribbed collar. The vertical ribbing is accented by intricate eyelet detailing, creating an elongated and feminine profile. Designed with a flattering, slightly flared A-line drape and deep-cut racerback-style armholes, it offers the perfect blend of casual comfort and polished style.\n\nDesign: High-neck sleeveless tank with racerback-style armholes.\nTexture: Intricate vertical rib-knit with pointelle eyelet detailing.\nFit: Relaxed, slightly flared A-line silhouette.\nNeckline: Thick ribbed crew-neck collar.\nFabric: Soft-touch, breathable knit-ideal for layering or wearing alone.",
  tags: [],
  msrpDollars: 237.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:41.111Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
